import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import { FaEdit, FaTrash, FaUser } from 'react-icons/fa'
import ReactTooltip from 'react-tooltip'
import { DateTime } from 'luxon'

import {
  Container,
  Row,
  Label,
  SubTitle,
  InfoText,
  Button
} from './styles'

export default function PromoCode ({
  data: promoCode,
  onEdit,
  onShowMembers,
  onDelete: handleDelete,
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleShowMembers = () => onShowMembers (promoCode)
  const handleEdit = () => onEdit (promoCode)

  const deletePromoCode = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (`/promo_codes/${promoCode.id}`, requestConfig)
      setDeleting (false)
      handleDelete (promoCode)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container>
      <SubTitle>
        {promoCode.code}
      </SubTitle>
      <InfoText>
        {promoCode.total_amount}
      </InfoText>
      <InfoText>
        {promoCode.available_amount}
      </InfoText>
      <InfoText>
        {DateTime.fromISO (promoCode.expires_at).toFormat ('dd/MM/yyyy')}
      </InfoText>
      <Row style={{justifySelf: 'center'}}>
        <Button onClick={handleShowMembers} data-for={`${promoCode.id}_members`} data-tip>
          <FaUser color='#FFC100' size={16}/>
        </Button>
        <Button onClick={handleEdit}>
          <FaEdit color='#35A7FF' size={18}/>
        </Button>
        <Button onClick={toggleAlertDialog}>
          {deleting ? (
            <ButtonLoading style={{margin: 0}}/>
          ) : (
            <FaTrash color='#FF3939' size={16}/>
          )}
        </Button>
          <ReactTooltip
            id={`${promoCode.id}_members`}
            effect='solid'
            place='top'
            backgroundColor='#252525'
            tooltipRadius='10'
          >
            <Label>
              Ver membros que utilizaram
            </Label>
          </ReactTooltip>
      </Row>
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente excluir este cupom promocional?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deletePromoCode}
        onClose={toggleAlertDialog}
        dangerous
      />
    </Container>
  )
}
